import type { BusinessNumberState, BusinessProfileFields as Fields } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { FormField } from '@/shared/ui';
import { BusinessNumberField } from './business-number-field';

const FIELDS = [
  { key: 'companyName', label: '상호', maxLength: 50 },
  { key: 'representativeName', label: '대표자', maxLength: 50 },
  { key: 'address', label: '사업장 주소', maxLength: 200 },
  { key: 'businessType', label: '업태', maxLength: 50 },
  { key: 'businessItem', label: '종목', maxLength: 50 },
  { key: 'invoiceEmail', label: '세금계산서 받을 이메일', maxLength: 254 },
  { key: 'contactName', label: '담당자명 (선택)', maxLength: 50 },
] as const;

export const BusinessProfileFields = ({
  values,
  errors,
  onChange,
  onCheck,
  businessState,
  isChecking,
}: {
  readonly values: Omit<Fields, 'contactName'> & { readonly contactName: string };
  readonly errors: Partial<Record<keyof Fields, string>>;
  readonly onChange: (key: keyof Fields, value: string) => void;
  readonly onCheck: () => void;
  readonly businessState: BusinessNumberState | null;
  readonly isChecking: boolean;
}): ReactElement => (
  <div className="grid gap-5 sm:grid-cols-2">
    <BusinessNumberField
      value={values.businessNumber}
      onChange={(value) => onChange('businessNumber', value)}
      onBlur={onCheck}
      state={businessState}
      isPending={isChecking}
      error={errors.businessNumber}
    />
    {FIELDS.map(({ key, label, maxLength }) => (
      <FormField
        key={key}
        label={label}
        isRequired={key !== 'contactName'}
        required={key !== 'contactName'}
        className="h-11"
        type={key === 'invoiceEmail' ? 'email' : 'text'}
        value={values[key]}
        maxLength={maxLength}
        error={errors[key]}
        onChange={(event) => onChange(key, event.target.value)}
      />
    ))}
  </div>
);
